import { clsx } from 'clsx';
import type { FieldError } from "react-hook-form";

export function inputErrorClass(error: boolean|string|FieldError = false) {
	return clsx(error && '!border-red-600');
}
